import InsideSalesCreateModalForm from './InsideSalesCreateModalForm';

export default InsideSalesCreateModalForm;
